/**
 * 完整代码
 */
// 关于月份： 在设置时要-1，使用时要+1

(function($, window, document, undefined) {
  let Calendar = function(elem, options) {
    this.$calendar = elem;

    this.defaults = {
      ifSwitch: true,
      hoverDate: false,
      backToday: false,
      dates: null,
      afterInit: null,
      onMonthChange: null,
      onClick: null
    };

    this.opts = $.extend({}, this.defaults, options);

    // console.log(this.opts);
  };

  Calendar.prototype = {
    showHoverInfo: function(obj) {
      // hover 时显示当天信息
      let _dateStr = $(obj).attr('data');
      let offset_t = $(obj).offset().top + (this.$calendar_today.height() - $(obj).height()) / 2;
      let offset_l = $(obj).offset().left + $(obj).width();
      let changeStr = addMark(_dateStr);
      let _week = changingStr(changeStr).getDay();
      let _weekStr = '';

      this.$calendar_today.show();

      this.$calendar_today
        .css({
          left: offset_l + 30,
          top: offset_t
        })
        .stop()
        .animate({
          left: offset_l + 16,
          top: offset_t
        });

      switch (_week) {
        case 0:
          _weekStr = 'Sunday';
          break;
        case 1:
          _weekStr = 'Monday';
          break;
        case 2:
          _weekStr = 'Tuesday';
          break;
        case 3:
          _weekStr = 'Wednesday';
          break;
        case 4:
          _weekStr = 'Thursday';
          break;
        case 5:
          _weekStr = 'Friday';
          break;
        case 6:
          _weekStr = 'Saturday';
          break;
      }

      this.$calendarToday_date.text(changeStr);
      this.$calendarToday_week.text(_weekStr);
    },

    showCalendar: function() {
      // 输入数据并显示
      let self = this;
      let dates = self.opts.dates;
      if (!dates) {
        dates = new Array();
      }
      let year = dateObj.getDate().getFullYear();
      let month = dateObj.getDate().getMonth() + 1;
      let dateStr = returnDateStr(dateObj.getDate());
      let firstDay = new Date(year, month - 1, 1); // 当前月的第一天

      this.$calendarTitle_text.text(`${year}年${dateStr.substr(4, 2)}月`);

      this.$calendarDate_item.each(function(i) {
        // allDay: 得到当前列表显示的所有天数
        let allDay = new Date(year, month - 1, i + 1 - firstDay.getDay());
        let allDay_str = returnDateStr(allDay);
        $(this)
          .find('span')
          .text(allDay.getDate())
          .attr('data', allDay_str);

        if (returnDateStr(new Date()) === allDay_str) {
          $(this).attr('class', 'item item-curDay');
        } else if (returnDateStr(firstDay).substr(0, 6) === allDay_str.substr(0, 6)) {
          $(this).attr('class', 'item item-curMonth');
        } else {
          $(this).attr('class', 'item');
        }
      });

      // 已选择的情况下，切换日期也不会改变
      if (self.selected_data) {
        let selected_elem = self.$calendar_date.find(`[data=${self.selected_data}]`);

        selected_elem.addClass('item-selected');
      }
      $('.num, .rest').remove();
      $('.calendar-date .item').each(function() {
        let date = $(this)
          .find('span')
          .attr('data');
        if (dates[date]) {
          if (typeof dates[date].orderCounts !== 'undefined') {
            let num = dates[date].orderCounts;
            if (num !== 0) {
              $(this).append(`<p class="num">${num}</p>`);
            } else {
              $(this).append('<p class="rest">休</p>');
            }
          } else {
            if (dates[date] === 'h' && $(this).hasClass('item-curMonth')) {
              $(this).append('<p class="rest">休</p>');
            }
          }
        } else {
          if ($(this).hasClass('item-curMonth')) {
            let day = new Date(addMark(date)).getDay();
            if (day === 0 || day === 6) {
              $(this).append('<p class="rest">休</p>');
            }
          }
        }
      });
    },

    renderDOM: function() {
      // 渲染DOM
      this.$calendar_title = $('<div class="calendar-title"></div>');
      this.$calendar_week = $('<ul class="calendar-week"></ul>');
      this.$calendar_date = $('<ul class="calendar-date"></ul>');
      this.$calendar_today = $('<div class="calendar-today"></div>');

      let _titleStr =
        '<div class="arrow">' +
        '<a href="#" class="title"></a>' +
        '<span class="arrow-prev"><</span>' +
        '<span class="arrow-next">></span>' +
        '</div>';

      let _weekStr =
        '<li class="item">日</li>' +
        '<li class="item">一</li>' +
        '<li class="item">二</li>' +
        '<li class="item">三</li>' +
        '<li class="item">四</li>' +
        '<li class="item">五</li>' +
        '<li class="item">六</li>';
      let _dateStr = '';
      let _dayStr = '<i class="triangle"></i>' + '<p class="date"></p>' + '<p class="week"></p>';

      for (let i = 0; i < 6; i++) {
        _dateStr +=
          '<li class="item"><span>26</span></li>' +
          '<li class="item"><span>26</span></li>' +
          '<li class="item"><span>26</span></li>' +
          '<li class="item"><span>26</span></li>' +
          '<li class="item"><span>26</span></li>' +
          '<li class="item"><span>26</span></li>' +
          '<li class="item"><span>26</span></li>';
      }

      this.$calendar_title.html(_titleStr);
      this.$calendar_week.html(_weekStr);
      this.$calendar_date.html(_dateStr);
      this.$calendar_today.html(_dayStr);

      this.$calendar.append(this.$calendar_title, this.$calendar_week, this.$calendar_date, this.$calendar_today);
      this.$calendar.show();
    },

    getDate: function() {
      return dateObj.getDate();
    },

    inital: function() {
      // 初始化
      let self = this;

      this.renderDOM();

      this.$calendarTitle_text = this.$calendar_title.find('.title');
      this.$backToday = $('#backToday');
      this.$arrow_prev = this.$calendar_title.find('.arrow-prev');
      this.$arrow_next = this.$calendar_title.find('.arrow-next');
      this.$calendarDate_item = this.$calendar_date.find('.item');
      this.$calendarToday_date = this.$calendar_today.find('.date');
      this.$calendarToday_week = this.$calendar_today.find('.week');

      this.selected_data = 0;

      if (this.opts.selected_data) {
        this.selected_data = this.opts.selected_data;
      }

      this.showCalendar();

      if (this.opts.ifSwitch) {
        this.$arrow_prev.bind('click', function() {
          let _date = dateObj.getDate();
          dateObj.setDate(new Date(_date.getFullYear(), _date.getMonth() - 1, 1));
          self.showCalendar();
          if (self.opts.onMonthChange) {
            self.opts.onMonthChange(dateObj.getDate());
          }
        });

        this.$arrow_next.bind('click', function() {
          let _date = dateObj.getDate();
          dateObj.setDate(new Date(_date.getFullYear(), _date.getMonth() + 1, 1));
          self.showCalendar();
          if (self.opts.onMonthChange) {
            self.opts.onMonthChange(dateObj.getDate());
          }
        });
      }

      if (this.opts.backToday) {
        let cur_month = dateObj.getDate().getMonth() + 1;

        this.$backToday.bind('click', function() {
          let item_month = $('.item-curMonth')
            .eq(0)
            .attr('data')
            .substr(4, 2);
          let if_lastDay = item_month !== cur_month ? true : false;

          if (!self.$calendarDate_item.hasClass('item-curDay') || if_lastDay) {
            dateObj.setDate(new Date());

            self.showCalendar();
          }
        });
      }

      // this.$calendarDate_item.hover(function () {
      //   self.showHoverInfo($(this));
      // }, function () {
      //   self.$calendar_today.css({left: 0, top: 0}).hide();
      // });
      if (self.opts.afterInit) {
        let $curDay = self.$calendar_date
          .find('.item-curDay')
          .find('span')
          .attr('data');
        self.opts.afterInit(addMark($curDay));
      }

      this.$calendarDate_item.click(function() {
        let _dateStr = $(this)
          .find('span')
          .attr('data');
        let _date = changingStr(addMark(_dateStr));
        let $curClick = null;

        self.selected_data = $(this).attr('data');

        dateObj.setDate(new Date(_date.getFullYear(), _date.getMonth(), 1));

        if (!$(this).hasClass('item-curMonth')) {
          self.showCalendar();
        }
        let $curDay = null;
        $curClick = self.$calendar_date.find(`[data=${_dateStr}]`);
        $curDay = self.$calendar_date
          .find('.item-curDay')
          .find('span')
          .attr('data');
        if (!$curClick.parent().hasClass('item-selected')) {
          self.$calendarDate_item.removeClass('item-selected');

          $curClick.parent().addClass('item-selected');
        }
        if (self.opts.onClick) {
          self.opts.onClick(addMark($curDay), addMark($curClick.attr('data')));
        }
      });
    },

    constructor: Calendar
  };

  $.fn.calendar = function(options) {
    console.log('carlendar.....');
    let calendar = new Calendar(this, options);

    return calendar.inital();
  };

  // ========== 使用到的方法 ==========

  let dateObj = (function() {
    let _date = new Date();

    return {
      getDate: function() {
        return _date;
      },

      setDate: function(date) {
        _date = date;
      }
    };
  })();

  function returnDateStr(date) {
    // 日期转字符串
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();

    month = month <= 9 ? `0${month}` : `${month}`;
    day = day <= 9 ? `0${day}` : `${day}`;

    return year + month + day;
  }

  function changingStr(fDate) {
    // 字符串转日期
    let fullDate = fDate.split('-');

    return new Date(fullDate[0], fullDate[1] - 1, fullDate[2]);
  }

  function addMark(dateStr) {
    // 给传进来的日期字符串加-
    if (dateStr) {
      return `${dateStr.substr(0, 4)}-${dateStr.substr(4, 2)}-${dateStr.substring(6)}`;
    }
  }

  // 条件1：年份必须要能被4整除
  // 条件2：年份不能是整百数
  // 条件3：年份是400的倍数
  function isLeapYear(year) {
    // 判断闰年
    return year % 4 == 0 && (year % 100 != 0 || year % 400 == 0);
  }
})(jQuery, window, document);



// WEBPACK FOOTER //
// ./src/assets/javascript/calendal.js